import { RegisteredAssetDetailModel } from '@casops/store/apis/registeredAssetsApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface AssetNameData {
  source: string;
  name: string;
}

interface UseAssetNameTableDataProps {
  asset?: RegisteredAssetDetailModel;
}

export const useAssetNameTableData = ({ asset }: UseAssetNameTableDataProps): AssetNameData[] => {
  const { t } = useTranslation();

  return useMemo<AssetNameData[]>(() => {
    if (!asset) {
      return [];
    }

    return [
      {
        source: t('AssetNameSourceServer'),
        name: asset.n,
      },
      {
        source: t('AssetNameSourceDevice'),
        name: asset.dn,
      },
    ];
  }, [asset, t]);
};
